import React, { useState, useEffect } from "react";
import { Box, Typography, Button, } from "@mui/material";
import { useOutletContext } from "react-router-dom";

const Premium = () => {
  const { open } = useOutletContext();
  return (
    <Box
      sx={{
        flexGrow: 1,
        p: "0",
        width: open ? "calc(100% - 288px)" : "calc(100% - 164px)",
        transition: "margin 0.3s ease",
        height: "calc(100% - 103px)",
        display: "flex",
        gap: 3,
        position: "absolute",
        top: 103,
      }}
    >
      <Box
        mt={10}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "12px",
          textAlign: "center",
          width: "100%",
          height: "calc(100% - 16px)",
          marginTop: 0,
          background: "#8F8F8F33",
          backdropFilter: "blur(5px)",
        }}
      >
        <Box sx={{ width: 480, height: 320, display: "flex", flexDirection: "column", padding: "23px 51px", alignItems: "center", background: "#fff", borderRadius: "18px" }}>
          <img src={`${process.env.PUBLIC_URL}/images/premium.svg`} alt="Premium" />
          <Typography variant="caption" sx={{ fontSize: "18px", fontWeight: "600", color: "#000000" }}>
            Upgrade to Premium
          </Typography>
          <Typography variant="caption" sx={{ fontSize: "14px", fontWeight: "400", color: "#000000" }}>
            Get multiple documents signed by multiple signers — faster and exclusive to premium users.
          </Typography>
          <Button variant="contained" sx={{ mt: "25px", width: '172px', height: 46, color: "#FFFFFF", background: "linear-gradient(to right, #2257AD, #B01121)", textTransform: "none", fontSize: "16px", borderRadius: "12px", border: "none", boxShadow: "none", fontWeight: "500",}} >
              Go Premium
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Premium;
